/* @flow strict */

import * as React from 'react';
import SimpleInput from '/client/src/components/forms/simpleInput';
import SimpleSelect from '../../components/forms/select';
import { PayCalculator } from '../../utils/buyService';
import { DefaultContainerContext } from '../../contexts/defaultContainer';
import { currency } from '/client/src/constants/';
import { format } from '../../utils/amountTransformation';

const FeeCalc = () => {
  const context = React.useContext(DefaultContainerContext);
  const siaExample = [
    {
      value: '100-2500-200-5000-300',
      label: '100-2500-200-5000-300'
    },
    {
      value: '200-2500-300-5000-400',
      label: '200-2500-300-5000-400'
    },
    {
      value: '300-2500-400-5000-500',
      label: '300-2500-400-5000-500'
    }
  ];

  const [paymentData, setPaymentData] = React.useState([]);
  const [tprice, setTprice] = React.useState(1000);
  const [YourFee, setTfee] = React.useState(1000);
  const [ttax, setTtax] = React.useState(100);

  const [siaSettings, setSiaSettings] = React.useState(siaExample[0].value);
  const [passFees, setPassFees] = React.useState(true);

  React.useEffect(() => {
    setPaymentData(PayCalculator(
      _.toNumber(tprice),
      _.toNumber(ttax),
      _.toNumber(YourFee),
      siaSettings,
      passFees
    ));
  }, []);

  React.useEffect(() => {
    setPaymentData(PayCalculator(
      _.toNumber(tprice),
      _.toNumber(ttax),
      _.toNumber(YourFee),
      siaSettings,
      passFees
    ));
  }, [tprice, YourFee, ttax, siaSettings, passFees]);

  return (
    <div className="sparxo-router-content">
      <div className="sparxo-page-container">
        <div className="row">
          <div className="col-md-2">
            <SimpleInput
              type='number'
              label='Price'
              id='tprice'
              name='tprice'
              value={tprice / 100}
              style={{
                background: '#ccc',
                padding: '6px'
              }}
              onChange={(e: any) => {
                setTprice(e.target.value * 100);
              }}
            />
          </div>
          <div className={`col-md-2 ${passFees ? '' : 'disabled'}`}>
            <SimpleInput
              type='number'
              label='Your fee'
              id='YourFee'
              name='YourFee'
              value={YourFee / 100}
              style={{
                background: '#ccc',
                padding: '6px'
              }}
              onChange={(e: any) => {
                setTfee(e.target.value * 100);
              }}
            />
          </div>
          <div className="col-md-2">
            <SimpleInput
              type='number'
              label='Your Tax'
              id='ttax'
              name='ttax'
              value={ttax / 100}
              style={{
                background: '#ccc',
                padding: '6px'
              }}
              onChange={(e: any) => {
                setTtax(e.target.value * 100);
              }}
            />
          </div>
          <div className="col-md-3">
            <SimpleSelect
              label={'CIA Settings example'}
              value={siaSettings}
              items={siaExample}
              callBack={(e: any) => {
                setSiaSettings(e.target.value);
              }}
              style={{
                background: '#ccc',
                padding: '6px'
              }}
            />
          </div>
        </div>
        <br/>
        <div className="row">
          <div className="col-md-12">
            <label style={{ display: 'flex', alignItems: 'center' }}>
              <input
                type="checkbox"
                onChange={(): void => setPassFees(!passFees)}
                checked={passFees}
                style={{ margin: 0 }}
              />
              &nbsp;Pass fees on to customer
            </label>
          </div>
          <br/>
          {paymentData.map(({ key, title, value }): any => (
            <div className="col-md-12" key={key}>
              <b>{title}</b> {format(currency[`${context.profileCurrent.currency}`], value, false, true)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeeCalc;
